module.exports = __webpack_public_path__ + "./images/7563704584c77af449c341c91f265182.webp";